/**
 * Calendar module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import TimeInfoBlock from '@src/Calendar/Pages/Blocks/TimeInfoBlock.vue';
import AddToCalendar from '@src/Calendar/Pages/AddToCalendar.vue';

export const setup = (app: App<Element>): void => {
    app.component('TimeInfoBlock', TimeInfoBlock);
    app.component('AddToCalendar', AddToCalendar);
};
